<section [formGroup]="stepForm">
  <mbs-alert
    *ngIf="!isProvider && passwordRecoveryEnabled && showRecoveryInfo"
    [attr.data-e2e]="elementsSelector.name.recoveryAlert"
    [icon]="true"
    [type]="mbsPopupType.warning">
    {{ 'wizards:recoveryAlertFirst' | i18next }}
    <a [href]="'mailto:' + providerEmail">{{ providerEmail }}</a>
    {{ 'wizards:recoveryAlertSecond' | i18next }}
  </mbs-alert>

  <mbs-form-group
    *ngIf="isNBF"
    [attr.data-e2e]="elementsSelector.name.nbfPasswordBlock">
    <div class="form-row">
      <div class="col-6">
        <mbs-input
          formControlName="password"
          name="Password"
          [appendButtons]="[
            {
              icon: showPassword ? 'fa fa-eye-slash' : 'fa fa-eye',
              id: 'changeTypePasswordOnEncryptionOptions',
              disabled: stepForm.get('password')?.value === InitialValue?.password || stepForm.get('password')?.disabled,
              type: 'secondary'
            }
          ]"
          [autocomplete]="'new-password'"
          [id]="elementsSelector.id.password"
          [label]="'wizards:password_label' | i18next"
          [placeholder]="'wizards:password_placeholder' | i18next"
          [type]="showPassword ? 'text' : 'password'"
          [validationWhitespace]="true"
          (buttonClick)="changeTypePassword()"
          (focus)="passwordFocusHandler($event)">
        </mbs-input>
      </div>
    </div>
  </mbs-form-group>

  <mbs-form-group
    *ngIf="!isNBF"
    [attr.data-e2e]="elementsSelector.name.notNBFPasswordBlock">
    <mbs-checkbox
      formControlName="isCryptWithPassword"
      name="isCryptWithPassword"
      [descriptionOutside]="false"
      [id]="'is-crypt-with-password'"
      [label]="'wizards:enable_is_crypt_with_pass_label' | i18next"
      [value]="'true'">
      <ng-template checkboxDescription>
        <div class="row">
          <div class="col-6">
            <mbs-form-group>
              <mbs-input
                #passFieldTwo
                formControlName="password"
                name="Password"
                [appendButtons]="[
                  {
                    icon: showPassword ? 'fa fa-eye-slash' : 'fa fa-eye',
                    id: 'changeTypePasswordOnEncryptionOptions',
                    disabled: stepForm.get('password')?.value === InitialValue?.password || stepForm.get('password')?.disabled,
                    type: 'secondary'
                  }
                ]"
                [autocomplete]="'new-password'"
                [id]="'encryption-options-password'"
                [label]="'wizards:password_label' | i18next"
                [placeholder]="'wizards:password_placeholder' | i18next"
                [type]="showPassword ? 'text' : 'password'"
                [validationWhitespace]="true"
                (buttonClick)="changeTypePassword()"
                (focus)="passwordFocusHandler($event)">
              </mbs-input>
            </mbs-form-group>
          </div>
        </div>
      </ng-template>
    </mbs-checkbox>
  </mbs-form-group>

  <mbs-form-group
    *ngIf="allowedRecovery && isNBF && (!isUnix || isNetBuild) && !ability.can('read', 'AgentLocal')"
    [attr.data-e2e]="elementsSelector.name.passwordRecoveryBlock">
    <div class="mb-2">
      <app-password-recovery-handler
        [backupVersionUpdated]="mainService.backupVersionUpdated"
        [hid]="this.mainService.hid"
        [passwordControl]="passwordControlFacade"
        [resultPoint]="{ path: resultPoint?.path, restorePoint: resultPoint?.restorePointId }"></app-password-recovery-handler>
    </div>
  </mbs-form-group>

  <mbs-form-group
    *ngIf="resultPoint && resultPoint.encryptionPasswordHint"
    [attr.data-e2e]="elementsSelector.name.hintBlock">
    <mbs-button
      type="primary"
      [isCtrl]="true"
      (click)="showPasswordHintChangeHandler()">
      {{ 'wizards:pass_hint_btn_text' | i18next: { state: showHint ? 'Hide' : 'Show' } }}
    </mbs-button>
    <div
      *ngIf="showHint"
      class="fw-bold"
      [attr.data-e2e]="elementsSelector.name.hintTextBlock">
      {{ resultPoint.encryptionPasswordHint }}
    </div>
  </mbs-form-group>
</section>
